import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiDialog: Components<Theme>['MuiDialog'] = {
  defaultProps: {
    maxWidth: 'xs',
  },
  styleOverrides: {
    paper: {
      borderRadius: scssVariables.BorderRadiusMedium,
      backgroundColor: scssVariables.ColorBlack10,
      border: `1px solid ${scssVariables.ColorBlack40}`,
      '& > form:first-child': {
        display: 'inherit',
        flexDirection: 'inherit',
        overflow: 'hidden',
      },
    },
    container: {
      alignItems: 'flex-start',
      marginTop: '5vh',
      maxHeight: '85vh',
      '@media (max-height: 800px)': {
        maxHeight: '95vh',
        marginTop: '5vh',
      },
      '@media (max-height: 600px)': {
        maxHeight: '100vh',
        marginTop: '0',
        alignItems: 'center', // Center on very short screens
      },
    },
  },
};
